module.exports = __webpack_public_path__ + "img/free_food_gallery01.71eea7f0.jpg";